const HalfLineIcon = () => {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
            <circle fill="none" cx="18" cy="18" r="18"/>
            <path fill="currentColor" d="M20 17v2h-4v-2z"/>
        </g>
    </svg>
  )
}

export default HalfLineIcon
